/** Staff roles whose home is Teaching, not the student enroll dashboard. */
export function isStaffRole(role: string | null | undefined): boolean {
  return role === "instructor" || role === "ta" || role === "tenant_admin";
}

/** Default authenticated landing for a known role (middleware / wrong-tenant bounce). */
export function resolveAuthenticatedHomePath(tenantSlug: string, role?: string | null): string {
  if (isStaffRole(role)) return `/t/${tenantSlug}/instructor`;
  return `/t/${tenantSlug}/dashboard`;
}

/**
 * Where to send the user immediately after a successful login. MT-1 S23a (FR-38 d): a session
 * belongs to one school, so there is no picker — always that school's role home.
 */
export function resolvePostLoginPath(tenantSlug: string, role?: string | null): string {
  return resolveAuthenticatedHomePath(tenantSlug, role);
}
